var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEditV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12Z",
    fill: "#4F5662"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9682 9.81455C17.3409 8.15508 16.2519 6.71997 14.8358 5.68659C13.4196 4.65321 11.7384 4.06686 10 4C8.26156 4.06686 6.58038 4.65321 5.16424 5.68659C3.7481 6.71997 2.65908 8.15508 2.03177 9.81455C1.98941 9.93439 1.98941 10.0656 2.03177 10.1855C2.65908 11.8449 3.7481 13.28 5.16424 14.3134C6.58038 15.3468 8.26156 15.9331 10 16C11.7384 15.9331 13.4196 15.3468 14.8358 14.3134C16.2519 13.28 17.3409 11.8449 17.9682 10.1855C18.0106 10.0656 18.0106 9.93439 17.9682 9.81455ZM10 13.5455C9.31434 13.5455 8.64408 13.3375 8.07397 12.9479C7.50386 12.5584 7.05952 12.0046 6.79713 11.3568C6.53474 10.7089 6.46608 9.99607 6.59985 9.30832C6.73361 8.62057 7.06379 7.98883 7.54863 7.49299C8.03346 6.99714 8.65118 6.65947 9.32367 6.52267C9.99615 6.38587 10.6932 6.45608 11.3267 6.72443C11.9601 6.99277 12.5016 7.4472 12.8825 8.03025C13.2634 8.6133 13.4668 9.29878 13.4668 10C13.4654 10.9399 13.0997 11.8408 12.4498 12.5054C11.8 13.17 10.919 13.544 10 13.5455Z",
    fill: "#4F5662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditV2);
export default __webpack_public_path__ + "static/media/ic-edit-v2.3d2ac1fea94b2b1ba5143790481a173d.svg";
export { ForwardRef as ReactComponent };